<template>
  <div @load="loading">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>
    <div class="gameplay_game_box_list gameplay_tap_box" >

      <div class="gameplay_tap_container odd" >

        <div class="gameplay_tap_row" v-for="(row, rowindex) in twoDimensionalTable" :key="rowindex">
          <button :disabled="buttonPushed" type="" class="attention_btn odd curs_def" v-for="(col, colindex) in row"
                  :key="rowindex-colindex" :style="disableDiv"
                  @click.prevent="sendAnswer(rowindex, colindex)"
                  :ref="rowindex === 0 ? (colindex + 1) : (rowindex * numOfCols) + (colindex + 1)">
            <img :src=col>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';


export default {
  name: 'attentionOdd',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      matrixImages: {
        SEVEN: {
          images: 'static/images/game_images/attention_01/AT_01_06a.svg',
        },
        THREE: {
          images: 'static/images/game_images/attention_01/AT_01_06a.svg',
        },
        CLOCK_1: {
          images: 'static/images/game_images/attention_01/AT_01_06a.svg',
        },
        CLOCK_2: {
          images: 'static/images/game_images/attention_01/AT_01_06b.svg',
        },
        SAD: {
          images: 'static/images/game_images/attention_01/AT_01_05a.svg',
        },
        SMILE: {
          images: 'static/images/game_images/attention_01/AT_01_05b.svg',
        },
        D_L: {
          images: 'static/images/game_images/attention_01/AT_01_03b.svg',
        },
        B_L: {
          images: 'static/images/game_images/attention_01/AT_01_03a.svg',
        },
        B: {
          images: 'static/images/game_images/attention_01/AT_01_04b.svg',
        },
        EIGHT: {
          images: 'static/images/game_images/attention_01/AT_01_04a.svg',
        },
        I: {
          images: 'static/images/game_images/attention_01/AT_01_01b.svg',
        },
        T: {
          images: 'static/images/game_images/attention_01/AT_01_01b.svg',
        },
        ONE: {
          images: 'static/images/game_images/attention_01/AT_01_01a.svg',
        },
        O: {
          images: 'static/images/game_images/attention_01/AT_01_02a.svg',
        },
        C: {
          images: 'static/images/game_images/attention_01/AT_01_02b.svg',
        },
        Q: {
          images: 'static/images/game_images/attention_01/AT_01_02b.svg',
        },
      },
      gameInfo: null, // NEW
      twoDimensionalTable: [], // NEW
      numOfRow: 0,
      numOfCols: 0,
      buttonPushed: false,
    };
  },
  mounted() {
    this.$nextTick(() => { this.loading(); });
  },
  created() {
    this.initGameData();
  },
  methods: {
    loading() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.createMatrix();
    },
    createMatrix() {
      this.numOfRow = this.getNumberOfRowsBasedOnLengthOfMatrix(this.gameInfo.length);
      this.numOfCols = this.getNumberOfColumnsBasedOnLengthOfMatrix(this.gameInfo.length);
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill(this.matrixImages[this.gameInfo.oddEnum].images));
      let indexOfCorrectAnswer = 0;
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          if (indexOfCorrectAnswer === this.gameInfo.correctIndex) this.twoDimensionalTable[i][j] = this.matrixImages[this.gameInfo.oddEnum2].images;
          indexOfCorrectAnswer += 1;
        }
      }
    },
    sendAnswer(answerRow, answerCol) {
      const answersIndex = answerRow === 0 ? answerCol + 1 : (answerRow * this.numOfCols) + answerCol + 1;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        let isCorrectAnswer = false;
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${answersIndex - 1}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.$refs[answersIndex][0].classList.add('odd_wrong');
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.$refs[answersIndex][0].classList.add('odd_correct');
            } else {
              // something bad happened
            }
          }
          setTimeout(() => {
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
            this.$refs[answersIndex][0].classList.remove('odd_wrong');
            this.$refs[answersIndex][0].classList.remove('odd_correct');
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    disableDiv() {
      return !this.buttonPushed ? 'cursor:pointer' : 'pointer-events:none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionOdd.vue